<template>
  <a-drawer
    :maskClosable="false"
    width="60%"
    :title="null"
    placement="right"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :bodyStyle="{ padding: 0, background: '#f5f5f5' }"
  >
    <div v-if="form && form.id" class="notice-detail-page">
      <div class="notice-header">
        <div class="header-content">
          <div class="header-left">
            <div class="notice-title">{{ form.newsTitle || '系统维护通知' }}</div>
            <div class="notice-date-row">
              <span class="notice-date">{{ formatDate(form.createTime) }}</span>
              <span class="separator">·</span>
              <span class="notice-tag" :class="getTagClass(form.newsType)">{{ getNewsTypeText(form.newsType) }}</span>
            </div>
          </div>
          <div class="header-right">
            <a-icon type="close" class="close-icon" @click="onClose" />
          </div>
        </div>
      </div>
      <div class="notice-body">

        <div class="notice-content-box">
          <div class="content-inner" v-html="form.newsContent || form.newsSketch || '暂无内容'"></div>
        </div>
      </div>
    </div>
    <div v-else-if="loading" class="loading-state">
      <a-spin size="large" tip="加载中..." />
    </div>
    <div v-else class="empty-state">
      <a-empty description="暂无数据" />
    </div>
  </a-drawer>
</template>
<script>
import { tableMixin } from '@/store/table-mixin'
import { getNotice } from '@/api/system/notice'
export default {
  mixins: [tableMixin],
  name: 'NoticeDetail',
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      placeholderImage: require('@/assets/images/defaultImg.png'),
    }
  },
  methods: {
    init(e) {
      if (!e || !e.id) {
        this.$message.error('缺少必要参数')
        return
      }
      this.loading = true
      this.visible = true
      getNotice({ id: e.id }).then((res) => {
        if (res && res.success !== false) {
          this.form = res.data || {}
        } else {
          this.$message.error(res.message || '获取详情失败')
          this.form = {}
        }
      }).catch(() => {
        this.$message.error('获取详情失败')
        this.form = {}
      }).finally(() => {
        this.loading = false
      })
    },
    onClose() {
      this.visible = false
      this.form = {}
      this.loading = false
    },
    handleCopyId() {
      const idText = `hoy-${this.form.id}`
      this.$copyText(idText).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        const input = document.createElement('input')
        input.value = idText
        document.body.appendChild(input)
        input.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch {
          this.$message.error('复制失败，请手动复制')
        }
        document.body.removeChild(input)
      })
    },
    getNewsTypeText(type) {
      const typeMap = {
        0: '系统通知',
        1: '用户消息',
      }
      return typeMap[type] !== undefined ? typeMap[type] : '系统通知'
    },
    getTagClass(type) {
      return type === 0 ? 'tag-system' : 'tag-user'
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
  },
}
</script>
<style lang="less" scoped>
.notice-detail-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}
.notice-header {
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  padding: 24px;
  flex-shrink: 0;
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .header-left {
      flex: 1;
      .notice-title {
        font-size: 20px;
        font-weight: 600;
        color: #262626;
        line-height: 28px;
        margin-bottom: 8px;
      }
      .notice-date-row {
        display: flex;
        align-items: center;
        gap: 12px;
        .notice-date {
          font-size: 14px;
          color: #8c8c8c;
          line-height: 22px;
        }
        .notice-tag {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 11px;
          line-height: 18px;
          &.tag-system {
            background: #fff1f0;
            border: 1px solid #ffccc7;
            color: #cf1322;
          }
          &.tag-user {
            background: #e6f7ff;
            border: 1px solid #91d5ff;
            color: #1890ff;
          }
        }
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;
      .close-icon {
        font-size: 18px;
        color: #ff4d4f;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
.notice-body {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  .message-id-section {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0;
    background: transparent;
    .message-id-text {
      color: #1890ff;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      user-select: none;
    }
    .separator {
      color: #d9d9d9;
      margin: 0 8px;
      font-size: 14px;
      line-height: 22px;
    }
    .copy-icon {
      color: #d9d9d9;
      font-size: 16px;
      cursor: pointer;
      transition: color 0.3s;
      &:hover {
        color: #1890ff;
      }
    }
  }
  .notice-content-box {
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    .content-inner {
      color: #262626;
      font-size: 14px;
      line-height: 24px;
      word-break: break-word;
      flex: 1;
      /deep/ p {
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      /deep/ ul, /deep/ ol {
        margin: 16px 0;
        padding-left: 24px;
        li {
          margin-bottom: 8px;
          line-height: 24px;
        }
      }
      /deep/ strong {
        font-weight: 600;
        color: #262626;
      }
      /deep/ img {
        max-width: 100%;
        height: auto;
        margin: 16px 0;
      }
    }
  }
}
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f5f5;
}
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f5f5;
}
</style>
